

import React, { memo } from 'react';
import { Dropdown } from '../../../../../../ui-kit';








// TODO: Get rid of this hof when will be no more projects with SUPER_RUSH_EDIT addon
// TODO: Also you should change graphql scheme by replacing RushEdit addon type from RushEditAddon to BooleanAddon
// TODO: Fix other backward compatibility code related to SUPER_RUSH_EDIT addon
/* istanbul ignore next */
function rushEditBackwardCompatibility(onChangeAddon) {
  return (addonValue) => {
    if (addonValue?.value) {
      return void onChangeAddon({ value: 'RUSH_EDIT', cost: addonValue.cost });
    }
    onChangeAddon(addonValue);
  };
}

function RushEdit({
  rushEdit,
  onChangeAddon,
  disabled,
  RUSH_EDIT
}) {
  return (
    <Dropdown
      options={RUSH_EDIT}
      defaultValue={rushEdit ? RUSH_EDIT.find((edit) => edit.value === rushEdit) : RUSH_EDIT[0]}
      label="Rush Edit"
      onChange={rushEditBackwardCompatibility(onChangeAddon('RUSH_EDIT'))}
      hideSeparators
      showSelectedSuffix
      disabled={disabled}
      type="BUTTON" />);


}

export default memo(RushEdit);